import { Directive } from '@angular/core';

@Directive({
  selector: 'tab4',
  standalone: false,
})
export class Tab4Directive {}
